module.exports = __webpack_public_path__ + "f277b35dba648287dfca567b2796f93b.svg";